import { Table } from '@tiptap/extension-table'

// Captures how wide the table was actually authored in the editor, as a
// percentage of the editor's own content width. RichTextEditor.vue keeps this
// in sync by measuring the table's real rendered width on every update.
// Left unset (null) for existing/pasted content that predates this feature —
// normalizeTableColumnWidths() in @team-milva/lab-pdfs falls back to 100% in
// that case, matching the previous unconditional-stretch behaviour.
export const CustomTable = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      widthPercent: {
        default: null,
        parseHTML: (element: Element) => {
          const value = (element as HTMLElement).getAttribute('data-width-percent')
          if (!value) return null
          const parsed = Number(value)
          return Number.isFinite(parsed) ? parsed : null
        },
        renderHTML: (attributes: Record<string, unknown>) => {
          const widthPercent = attributes.widthPercent as number | null
          if (!widthPercent) return {}
          return { 'data-width-percent': String(widthPercent) }
        },
      },
    }
  },
})
